import React from 'react'
import cn from "classnames"
import PropTypes from 'prop-types'
import injectStyles from "react-jss"
import theme from "../../styles/theme"

const Quote = ({classes, className, bodyClassName, quote, quote_attribution, imageQuote=false}) => (
    <div key="quote" className={cn(classes.quoteContainer, className)}>
        <aside className={cn(classes.quoteBody, bodyClassName)}>
            <div className={cn(classes.quote, {[classes.quoteSmall]: imageQuote})} dangerouslySetInnerHTML={{__html: quote}} />
            {quote_attribution && <div className={classes.quoteAttribution} dangerouslySetInnerHTML={{__html: quote_attribution}}></div>}
        </aside>
    </div>
)

Quote.propTypes = {
    quote: PropTypes.string,
    quote_attribution: PropTypes.string,
}

export default injectStyles({
    quoteContainer: {
        "& p": {
            margin: 0,
            padding: 0,
            fontSize: "0.6rem",
            lineHeight: "1.2rem",
            [theme.breakpoint("mobile")]: {
                ...theme.font.p,
            },
        },
    },
    quoteBody: {
        backgroundColor: theme.colors.white,
        padding: theme.spacing.tiny,
        margin: theme.spacing.tiny,
        maxWidth: 260,
        [theme.breakpoint("mobile")]: {
            maxWidth: 360,
            padding: `${theme.spacing.small} ${theme.spacing.small}`,
            margin: theme.spacing.small,
        },
        [theme.breakpoint("tablet")]: {
            padding: `${theme.spacing.small} ${theme.spacing.normal}`,
            margin: theme.spacing.normal,
        },
    },
    quote: {
        ...theme.font.pullQuote,
    },
    quoteSmall: {
        ...theme.font.pullQuoteSmall,
    },
    quoteAttribution: {
        ...theme.font.pullQuoteAttribution,
        float: "right",
        marginLeft: theme.spacing.small,
        position: "relative",
        "& p": {
            ...theme.font.pullQuoteAttribution,
        },
        "&:before": {
            content: '"-"',
            position: "absolute",
            left: -8,
            height: "100%",
            display: "flex",
            alignItems: "center"
        }
    },
})(Quote)





// WEBPACK FOOTER //
// ./src/components/Widgets/Quote.js